// Get location map elements
var $locationMap = $('#location-map');
var $locations = $('[data-location]');
var $amboyLocationsGoBtn = $('#amboy-locations-go');
var $amboyLocationsGoClearBtn = $('#amboy-locations-clear');
var $amboyLocationsZipCity = $('#amboy-locations-zip-city');
var $amboyLocationsSearchRadius = $('#amboy-locations-search-radius');
var $amboyLocationsCounty = $('#amboy-locations-county');
var $amboyLocationsFeatureCheckboxes = $('input[name="amboy-locations-features"]');
var $locationListInfo = $('[data-location-list-info]');

// Declare Google Maps objects
var gmarkers = [];
var map, markers, circle;

// Declare object for storing location data, elements, and markers
var locationsData;
var oldBridge = {lat: 40.379870, lng: -74.308490};

// Setup the location map if it exists on the page
if ($locationMap.length > 0) {

  var geocoder = new google.maps.Geocoder();

  // A single info window for displaying branch information when markers are clicked
  var infoWindow = new google.maps.InfoWindow();

  // Initialize location map on page load
  initializeMap();

  // empty county selection if value
  $amboyLocationsZipCity.on('blur', function () {
    if ($(this).val() !== '') {
      $amboyLocationsCounty.val('');
    }
  });

  // empty zipcode value if value is selected
  $amboyLocationsCounty.on('change', function () {
    if ($(this).find(':selected').val() !== '') {
      $amboyLocationsZipCity.val('');
      $amboyLocationsSearchRadius.val('');
    }
  });

  // Register change event on location controls
  $amboyLocationsGoBtn.on('click', searchByZipRadius);
  $amboyLocationsGoClearBtn.on('click', resetLocations);

  // Register keypress event on location controls
  $amboyLocationsGoBtn.on('keydown', submitsearchByZipRadiusOnEnterKey);
  $amboyLocationsGoClearBtn.on('keydown', resetLocations);
}

function initializeMap() {
  map = new google.maps.Map(
    $locationMap.get(0), {
      zoom: 10,
      center: oldBridge,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
  );

  // Create a marker for each location and add it to the map
  markers = $locations.map(function (index, domElement) {
    var locationData = $(domElement).data('location');

    var marker = new google.maps.Marker({
      position: locationData.position,
      map: map,
      animation: google.maps.Animation.DROP
    });

    //When marker is clicked, display info window with location's info
    marker.addListener('click', function() {
      infoWindow.setContent($(domElement).find('.location-info').html());
      infoWindow.open(map, marker);
    });

    gmarkers.push(marker);

    return marker;
  }).get();

  // Assign locations data
  locationsData = $locations.map(function (index, domElement) {
    return {
      data: $(domElement).data('location'),
      $element: $(domElement),
      marker: markers[index]
    };
  }).get();

}

// reset search filters and map
function resetLocations() {
  $(':input[type="text"]').val('');
  $(':input[type="checkbox"]').prop('checked', false);
  $('select').prop('selectedIndex', 0);

  initializeMap();
  orderLocationsAlphabetically();
}

// When enter key is pressed in the event, submit the find locations
function submitsearchByZipRadiusOnEnterKey(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    searchByZipRadius();
  }
}

// Find locations
function searchByZipRadius() {
  // search values
  var zipCitySearchVal = $amboyLocationsZipCity.val();
  var countySearchVal = $amboyLocationsCounty.find(':selected').val();
  var locationFeatures = $amboyLocationsFeatureCheckboxes.filter(':checked').map(function() { return $(this).val() }).get();
  var radiusSearchVal = parseInt($amboyLocationsSearchRadius.find(':selected').val());
  var radiusVal = parseInt(radiusSearchVal, 10) * 1600;

  if (zipCitySearchVal) {
    geocoder.geocode(
      { 'address': zipCitySearchVal },
      function (results, status) {
        if (status == 'OK') {

          // http://www.geocodezip.com/v3_MW_example_map3_radiusSearch.html
          var position = results[0].geometry.location;

          // Center map on position
          map.setCenter(position);

          for (var i = 0; i < gmarkers.length; i++) {
            gmarkers[i].setMap(map);
          }

          if (radiusSearchVal === 5) {
            map.setZoom(11);
          } else if (radiusSearchVal === 10) {
            map.setZoom(10);
          } else {
            map.setZoom(10);
          }

          if (radiusSearchVal > 0) {
            if (circle) {
              circle.setMap(null);
            }

            circle = new google.maps.Circle({
              center: position,
              radius: radiusVal,
              fillOpacity: 0.10,
              fillColor: '#FF0000',
              map: map
            });
          } else {
            if (circle) {
              circle.setMap(null);
            }
          }

          var filteredLocationsData = locationsData
            .filter(ld => // Filter by features
              locationFeatures.every(lf => ld.data.features.includes(lf))
            );

          // Order locations by distance from position
          orderByRadiusDistance(position, filteredLocationsData, radiusVal);

        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      }
    );
  }

  if (countySearchVal) {
    geocoder.geocode(
      { 'address': countySearchVal },
      function (results, status) {
        if (status == 'OK') {

          // radius search, clear circle
          if (circle) {
            circle.setMap(null);
          }

          // http://www.geocodezip.com/v3_MW_example_map3_radiusSearch.html
          var position = results[0].geometry.location;

          // Center map on position
          map.setCenter(position);
          map.setZoom(10);

          // Determine which locations should be shown based on checkboxes
          var filteredLocationsData = locationsData
            .filter(locationData =>
              countySearchVal === locationData.data.county
            )
            .filter(locationData => // Filter by features
              locationFeatures.some(locationFeature => locationData.data.features.includes(locationFeature)) || locationFeatures.length === 0
            );

          // Only show locations that satisfy the filters
          locationsData.forEach(locationData => {
            locationData.$element.hide();
            locationData.marker.setVisible(false);
          });
          filteredLocationsData.forEach(locationData => {
            locationData.$element.show();
            locationData.marker.setVisible(true);
            locationData.marker.setMap(map);
          });

          // Set location list info text
          screenReaderAnnouncement();

        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      }
    );
  }

  if (zipCitySearchVal === '' && countySearchVal === '') {
    filterLocations();
  }

}

function screenReaderAnnouncement() {
  // Set location list info text
  const locations = $('[data-location]:visible').length;
  $locationListInfo.text(`${$locationListInfo.data('location-list-text')}: ${locations}`);
}

function filterLocations() {
  // Get selected checkboxes
  var locationFeatures = $amboyLocationsFeatureCheckboxes.filter(':checked').map(function() { return $(this).val() }).get();

  // Determine which locations should be shown based on checkboxes
  var filteredLocationsData = locationsData
    .filter(ld => // Filter by features
      locationFeatures.every(lf => ld.data.features.includes(lf))
    );

  // Only show locations that satisfy the filters
  locationsData.forEach(ld => {
    ld.$element.hide();
    ld.marker.setVisible(false);
  });
  filteredLocationsData.forEach(ld => {
    ld.$element.show();
    ld.marker.setVisible(true);
  });

  // Set location list info text
  screenReaderAnnouncement();
}

function hideAllMapMarkers(position) {
  for (var i = 0; i < gmarkers.length; i++) {
    if (google.maps.geometry.spherical.computeDistanceBetween(gmarkers[i].getPosition(), position)) {
      gmarkers[i].setMap(null);
    }
  }
}

function hideAllLocations() {
  locationsData.forEach(ld => {
    ld.$element.hide();
  });
}

function showAllMapMarkers(position) {
  for (var i = 0; i < gmarkers.length; i++) {
    if (google.maps.geometry.spherical.computeDistanceBetween(gmarkers[i].getPosition(), position)) {
      gmarkers[i].setMap(map);
    }
  }
}

function showFilteredMapMarkersByRadius(position, radius, filteredLocationsByDistance) {
  for (var i = 0; i < gmarkers.length; i++) {
    if (google.maps.geometry.spherical.computeDistanceBetween(gmarkers[i].getPosition(), position) < radius) {
      filteredLocationsByDistance.forEach(ld => {
        if (ld.locationPosition === gmarkers[i].getPosition()) {
          gmarkers[i].setVisible(true);
          gmarkers[i].setMap(map);
        }
      });
    }
  }
}

function showFilteredMapMarkers(position, filteredLocationsByDistance) {
  for (var i = 0; i < gmarkers.length; i++) {
    if (google.maps.geometry.spherical.computeDistanceBetween(gmarkers[i].getPosition(), position)) {
      filteredLocationsByDistance.forEach(ld => {
        if (ld.locationPosition === gmarkers[i].getPosition()) {
          gmarkers[i].setMap(map);
        }
      });
    }
  }
}

// Orders locations in the DOM based on distance from the specified position
function orderByRadiusDistance(position, filteredLocations, radius) {
  // Sort all filtered locations
  var filteredLocationsByDistance = filteredLocations.map(ld => {
    return {
      $element: ld.$element,
      locationPosition: ld.marker.getPosition(),
      distance: google.maps.geometry.spherical.computeDistanceBetween(position, ld.marker.getPosition())
    };
  })
  .sort((a,b) => a.distance - b.distance);

  if (radius > 0) {
    /* show filtered results within radius */
    hideAllLocations();
    hideAllMapMarkers(position);
    showFilteredMapMarkersByRadius(position, radius, filteredLocationsByDistance);

    // show location if within radius search
    filteredLocationsByDistance.forEach(ld => {
      if (ld.distance < radius) {
        ld.$element.show();
      }
    });

    // Set location list info text
    screenReaderAnnouncement();

  } else {
    /* show filtered results */
    hideAllMapMarkers(position);
    showFilteredMapMarkers(position, filteredLocationsByDistance)
    hideAllLocations();

    filteredLocations.forEach(ld => {
      ld.$element.show();
    });

    // Sort locations
    var locationsByDistance = filteredLocations.map(ld => {
      return {
        $element: ld.$element,
        distance: google.maps.geometry.spherical.computeDistanceBetween(position, ld.marker.getPosition())
      };
    })
    .sort((a,b) => a.distance - b.distance);

    // Detach and re-append locations in order of distance
    locationsByDistance.forEach(lbd => {
      var $parent = lbd.$element.parent();
      lbd.$element.detach().appendTo($parent);
    });

    // Set location list info text
    screenReaderAnnouncement();

  }
}

function orderLocationsAlphabetically() {
  locationsData.forEach(ld => {
    ld.$element.show();
  });

  // Sort locations
  var locationsSortedAlphabetically = locationsData.sort((a,b) => a.location - b.location);

  // Detach and re-append locations in order of distance
  locationsSortedAlphabetically.forEach(location => {
    var $parent = location.$element.parent();
    location.$element.detach().appendTo($parent);
  });

  // Set location list info text
  screenReaderAnnouncement();
}
